import React from "react";
import HeaderForm from "./HeaderForm";
import CourierInfo from "./CourierInfo";
import DeliveryMethodSelector from "./DeliveryMethodSelector";
import PickupTimeSelector from "./PickupTimeSelector";
import AddressInfo from "./AddressInfo";
import NotificationMessage from "./NotificationMessage";
import ActionButtons from "./ActionButtons";
import {clsx} from "clsx";
import {isMobile} from "react-device-detect";

const PickupForm = ({
                        activeTab,
                        onTabChange,
                        onClose,
                        addressShip,
                        noted,
                        phoneNumber,
                        name,
                        addressPickup,
                        animate,
                        handleConfirm,
                        handleSelectPickupTime,
                        errors
                    }) => (
    <div
        className={clsx("w-full space-y-[10px] md:space-y-4 text-sm",
            isMobile && animate.direction === 'right' && 'animate-scaleInRight')}>
        <HeaderForm/>
        <CourierInfo/>
        <div className='bg-white p-4 rounded-[10px] space-y-4'>
            <DeliveryMethodSelector activeTab={activeTab} onTabChange={onTabChange}/>
            <PickupTimeSelector handleSelectPickupTime={handleSelectPickupTime} errors={errors}/>
        </div>
        <AddressInfo
            onClose={onClose}
            addressPickup={addressPickup}
            addressShip={addressShip}
            noted={noted}
            phoneNumber={phoneNumber}
            name={name}
        />
        <NotificationMessage/>
        <ActionButtons onClose={onClose} onConfirm={handleConfirm}/>
    </div>
);
export default PickupForm;